import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Button as MatButton } from 'react-materialize';
import { COLOR } from '../../utils/constants.js';
import SVG from 'react-inlinesvg';
import { getExtension } from '../../utils/utils.js'


const ButtonStyled = styled(MatButton)`
    display: flex;
    margin: ${props => props.margin ? props.margin : '0 0'};
    float: ${props => props.float ? props.float : ''};
    width: ${props => props.width ? props.width : ''};
    height: ${props => props.height ? props.height : '40px'};
    background: ${props => props.bg_color ? props.bg_color : 'none'};
    color: ${props => props.text_color ? props.text_color : COLOR.black};
    border: ${props => props.border_color ? '1px solid ' + props.border_color : 'none'};
    border-width: ${props => props.border_width ? props.border_width : 'none'};
    &:hover {
        background: ${props => props.bg_color 
            ? '#' + lightenColor(props.bg_color.replace('#', ''), 15) 
            : 'none' 
        };
        border: ${props => props.border_color 
            ? '1px solid #' + lightenColor(props.border_color.replace('#', ''), 15) 
            : 'none' 
        };
        border-width: ${props => props.border_width ? props.border_width : 'none'};
        color: ${props => props.text_color 
            ? '#' + lightenColor(props.text_color.replace('#', ''), 15) 
            : 'none' 
        };
    }
    &:focus {
        background: ${props => props.bg_color ? props.bg_color : 'none'};
    }
`;

const IconContent = styled.div`
    width: ${props => props.ic_size ? props.ic_size : '25px'};
    height: ${props => props.ic_size ? props.ic_size : '25px'};
    margin-right: ${props => props.ic_separation ? props.ic_separation : '15px'};
`;

const SVGStyled = styled(SVG)`
    display: block;
    width: ${props => props.ic_size ? props.ic_size : '25px'};
    height: ${props => props.ic_size ? props.ic_size : '25px'};
    ${props => props.ic_color ? 'fill: ' + props.ic_color : 'none'};
`;

const Icon = styled.img`
    display: block;
    height: 100%;
    width: 100%;
    margin-right: ${props => props.ic_separation ? props.ic_separation : '15px'};
`;

function lightenColor(color, percent) {
    var num = parseInt(color,16),
    amt = Math.round(1.70 * percent),
    R = (num >> 16) + amt,
    B = (num >> 8 & 0x00FF) + amt,
    G = (num & 0x0000FF) + amt;
    return (0x1000000 + (R<255?R<1?0:R:255)*0x10000 + (B<255?B<1?0:B:255)*0x100 + (G<255?G<1?0:G:255)).toString(16).slice(1);
};


const Button = ({
    id,
    className='valign-wrapper', //Must have className to apply styled component css properties.
    width,
    height,
    disabled = false, 
    onClick,
    ic_path,
    ic_size,
    ic_separation,
    ic_color,
    bg_color, 
    border_color, 
    border_width, 
    text_color, 
    margin,
    float,
    children
}) => {
    var icContent
    if (ic_path) {
        const icExtension = getExtension(ic_path)
        icContent = (icExtension === 'svg' && ic_color) ? 
        <IconContent
            ic_size={ic_size}
            ic_separation={ic_separation}>
            <SVGStyled 
                ic_size={ic_size}
                src={ic_path}
                ic_color={ic_color}
                />
        </IconContent>
        :
        <IconContent
            ic_size={ic_size}
            ic_separation={ic_separation} >
            <Icon 
                ic_size={ic_size}
                src={ic_path}/>
        </IconContent>;
    } else {
        icContent = null
    }

    return (
        <ButtonStyled
            id={ id }
            className={ className }
            disabled={ disabled }
            onClick={ onClick }
            margin={ margin }
            width={ width }
            height={ height }
            bg_color={ bg_color }
            border_color={ border_color }
            border_width={ border_width }
            text_color={ text_color }
            float={ float }>
            { icContent }
            { children }
        </ButtonStyled>
    )
}

export default Button;